export enum CartPaymentStatuses {
  Pending = 'Pending',
  Success = 'Success',
  Rejected = 'Rejected',
}
